module.exports = ".btn-email, .dropdown-email {\n    width: 100%;\n    text-align: left;    \n}\n\na {\n    cursor: pointer;\n}\n\ni.fa {\n    float: right;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/communication/templates/components/select-type/select-type.component.css
// module id = ./src/app/organization/components/communication/templates/components/select-type/select-type.component.css
// module chunks = main